import { useIntl } from 'react-intl';

/** Copies of the flight row's colour picker and date picker (English defaults; Tolgee keys under spc.flightSettings). */
export function useFlightCopies() {
  const { formatMessage } = useIntl();

  return {
    colorPickerLabels: {
      hue: formatMessage({ defaultMessage: 'Hue', id: 'spc.flightSettings.flight.color.hue' }),
      mostPopular: formatMessage({
        defaultMessage: 'Most popular:',
        id: 'spc.flightSettings.flight.color.mostPopular'
      }),
      reset: formatMessage({ defaultMessage: 'Reset', id: 'spc.flightSettings.flight.color.reset' }),
      saturation: formatMessage({ defaultMessage: 'Saturation', id: 'spc.flightSettings.flight.color.saturation' }),
      save: formatMessage({ defaultMessage: 'Save changes', id: 'spc.flightSettings.flight.color.save' })
    },
    colorPickerTitle: formatMessage({
      defaultMessage: 'Change flight color',
      id: 'spc.flightSettings.flight.color.title'
    }),
    markerCoverageWarning: formatMessage({
      defaultMessage: 'Some line items run on days outside the flight schedules.',
      id: 'spc.flightSettings.flight.dates.uncoveredLineItems'
    }),
    markerName: {
      one: formatMessage({ defaultMessage: 'line item', id: 'spc.flightSettings.flight.lineItem.one' }),
      other: formatMessage({ defaultMessage: 'line items', id: 'spc.flightSettings.flight.lineItem.other' })
    },
    timeWindow: formatMessage({ defaultMessage: 'Time window', id: 'spc.flightSettings.flight.timeWindow' })
  };
}
